module.exports = __webpack_public_path__ + "img/Pages-icon.svg?cfa03372403146bd6bd2f65051d04f59";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pages/fonts/pages-icon/Pages-icon.svg?-u69vo5
// module id = 624
// module chunks = 0